import React, { useEffect } from 'react';
import { bool, node } from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';
import AppContext from '../../../logged_out_homepage/context/AppContext';
import { sendMixPanelEvent } from '../../../logged_out_homepage/utils/biEvents';
import { MP_SHOW_PAGE_NAME } from '../../../logged_out_homepage/utils/biEvents/events/mixPanelEvents';
import { MIXPANEL_EVENT_TYPES } from '../../../logged_out_homepage/utils/types/mixpanelEventTypes';

import './style.scss';

const EntryWrapper = ({ displayBrandCampaign, removeBottomSpace = false, children }) => {
    const { locale } = getContext();

    useEffect(() => {
        sendMixPanelEvent({
            eventName: MP_SHOW_PAGE_NAME,
            eventType: MIXPANEL_EVENT_TYPES.PAGE_VIEW,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const context = {
        displayBrandCampaign,
    };

    return (
        <div
            className={classNames('logged-out-homepage', {
                'p-b-0': removeBottomSpace,
                'logged-out-homepage-de': locale === SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE,
            })}
        >
            <AppContext.Provider value={context}>{children}</AppContext.Provider>
        </div>
    );
};

EntryWrapper.propTypes = {
    displayBrandCampaign: bool,
    removeBottomSpace: bool,
    children: node,
};

export default EntryWrapper;
